const CheckCryptoValue = (cryptoKey:string,gameWords:string[]) => {
    const normalizedKey = cryptoKey.toUpperCase();

    if (normalizedKey.length !== 9) {
      return (`Ключ длиной ${normalizedKey.length} вместо 9!`);
    }

    if (new Set(normalizedKey).size !== 9) {
      return ("В ключе есть повторяющиеся буквы!");
    }

    if (gameWords.length === 0) {
      return ("Массив слов пуст!");
    }

    if (gameWords.some((word) => word.trim() === "")) {
      return ("Есть пустое слово!");
    }

    for (const word of gameWords) {
      for (const letter of word.toUpperCase()) {
        if (!normalizedKey.includes(letter)) {
          return (
            `Буква "${letter}" из слова "${word}" отсутствует в ключе!`
          );
        }
      }
    }

    return true;
  };
export default CheckCryptoValue;